import { IShouldUseCustomDisclaimer } from './types';

export const shouldUseCustomDisclaimer: IShouldUseCustomDisclaimer = (
  isCustomDisclaimerAvailable,
  isMoreInfoDisclaimerFlagEnabled
) => isCustomDisclaimerAvailable && isMoreInfoDisclaimerFlagEnabled;
